import { render, staticRenderFns } from "./FrequentlyAsked.vue?vue&type=template&id=2682225d&scoped=true&"
import script from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
export * from "./FrequentlyAsked.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyAsked.vue?vue&type=style&index=0&id=2682225d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682225d",
  null
  
)

export default component.exports